import { Icon, IconRegistrySingleton } from "../../../Syntess.Web.Shared/Utils/IconRegistry";

class PortalIconRegistry extends IconRegistrySingleton {
    constructor() {
        super();
        this.map.push(
            new Icon("file", "icon-file"),
            new Icon("excel", "icon-file-excel-o"),
            new Icon("word", "icon-file-word-o"),
            new Icon("powerpoint", "icon-file-powerpoint-o"),
            new Icon("image", "icon-file-image-o"),
            new Icon("pdf", "icon-file-pdf-o")
        );
    }

    public static get instance(): PortalIconRegistry {
        if (!PortalIconRegistry._instance) {
            PortalIconRegistry._instance = new PortalIconRegistry();
        }
        return PortalIconRegistry._instance;
    }
}

export var IconRegistry = PortalIconRegistry.instance;
